export const menuListData = [
  {
    category: "추천메뉴",
    num: 1,
    name: "마약고추장돼지덮밥",
    price: 11000,
    salePrice: 11000,
    img: "1.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [0, 1, 2],
    isDescription: "누구나 좋아하는 1992덮밥&짜글이의 스테디셀러",
    bedg: ["추천"],
  },
  {
    category: "추천메뉴",
    num: 2,
    name: "김치고기덮밥",
    price: 11000,
    salePrice: 11000,
    img: "2.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [0, 1, 3],
    isDescription:
      "한국의 가장 전통적인 맛을 극대화시킨 담백한 김치고기(삼겹살)덮밥",
    bedg: ["추천"],
  },
  {
    category: "추천메뉴",
    num: 3,
    name: "돈부리덮밥",
    price: 11000,
    salePrice: 11000,
    img: "3.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [0, 1],
    isDescription:
      "고퀄리티의 돈가스와 특제소스로 풍미를 살려 식감과 맛 모두 겸비한 돈부리덮밥",
    bedg: ["추천"],
  },
  {
    category: "추천메뉴",
    num: 4,
    name: "닭갈비덮밥",
    price: 11000,
    salePrice: 11000,
    img: "4.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [0, 1, 3],
    isDescription:
      "달콤한 특제소스와 쫄깃한 닭고기에 신선한 채소들이 어우러진 닭갈비덮밥",
    bedg: ["추천"],
  },
  {
    category: "추천메뉴",
    num: 5,
    name: "마약육회덮밥",
    price: 11000,
    salePrice: 11000,
    img: "5.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [0, 1, 2, 3],
    isDescription:
      "신선한 육회와 특제소스의 환상케미, 고소함이 일품인 육회덮밥",
    bedg: ["추천"],
  },
  {
    category: "추천메뉴",
    num: 6,
    name: "된장 짜글이(조리 10분~15분)",
    price: 11500,
    salePrice: 11500,
    img: "6.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [1, 4],
    isDescription: "특제된장으로 끓여낸 진하고 구수한 전라도식 전통된장짜글이",
    bedg: ["추천"],
  },
  {
    category: "덮밥",
    num: 7,
    name: "마약고추장돼지덮밥",
    price: 11000,
    salePrice: 11000,
    img: "7.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [0, 1, 2],
    isDescription: "누구나 좋아하는 1992덮밥&짜글이의 스테디셀러",
    bedg: ["추천"],
  },
  {
    category: "덮밥",
    num: 8,
    name: "김치고기덮밥",
    price: 11000,
    salePrice: 11000,
    img: "8.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [0, 1, 3],
    isDescription:
      "한국의 가장 전통적인 맛을 극대화시킨 담백한 김치고기(삼겹살)덮밥",
    bedg: ["추천"],
  },
  {
    category: "덮밥",
    num: 9,
    name: "돈부리덮밥",
    price: 11000,
    salePrice: 11000,
    img: "9.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [0, 1],
    isDescription:
      "고퀄리티의 돈가스와 특제소스로 풍미를 살려 식감과 맛 모두 겸비한 돈부리덮밥",
    bedg: ["추천"],
  },
  {
    category: "덮밥",
    num: 10,
    name: "닭갈비덮밥",
    price: 11000,
    salePrice: 11000,
    img: "10.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [0, 1, 3],
    isDescription:
      "달콤한 특제소스와 쫄깃한 닭고기에 신선한 채소들이 어우러진 닭갈비덮밥",
    bedg: ["추천"],
  },
  {
    category: "덮밥",
    num: 11,
    name: "마약제육덮밥",
    price: 11000,
    salePrice: 11000,
    img: "11.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [0, 1, 2, 3],
    isDescription:
      "매콤한 고기가 푸짐하게 올라가 있는 중독성 있는 매운맛의 제육덮밥",
    bedg: [],
  },
  {
    category: "덮밥",
    num: 12,
    name: "마늘데리야끼 우삼겹덮밥",
    price: 11500,
    salePrice: 11500,
    img: "12.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [0, 1, 2],
    isDescription:
      "매콤달달 특제소스와 직화로 구운 우삼겹이 만나 풍미를 더한 마늘데리야끼 우삼겹덮밥",
    bedg: [],
  },
  {
    category: "덮밥",
    num: 13,
    name: "해물쌈장덮밥(고기덮밥)",
    price: 11000,
    salePrice: 11000,
    img: "13.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [0, 1, 2],
    isDescription: "감칠맛 도는 해물 쌈장과 비벼 먹는 삼겹살 고기 덮밥",
    bedg: [],
  },
  {
    category: "덮밥",
    num: 13,
    name: "매콤쭈꾸미덮밥(매움)",
    price: 11000,
    salePrice: 11000,
    img: "13.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [0, 1, 2, 3, 6],
    isDescription:
      "매콤한 특제소스와 쫄깃한 쭈꾸미를 함께 볶아 식감을 극대화시킨 쭈꾸미덮밥",
    bedg: ["맵기3"],
  },
  {
    category: "덮밥",
    num: 14,
    name: "마약육회덮밥",
    price: 11000,
    salePrice: 11000,
    img: "14.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [0, 1, 2, 3],
    isDescription:
      "신선한 육회와 특제소스의 환상케미, 고소함이 일품인 육회덮밥",
    bedg: ["추천"],
  },
  {
    category: "덮밥",
    num: 15,
    name: "된장 삼겹덮밥",
    price: 11000,
    salePrice: 11000,
    img: "15.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [0, 1, 2],
    isDescription: "된장 소스로 볶아낸 감칠맛나는 신메뉴 삼겹살 덮밥",
    bedg: [],
  },
  {
    category: "덮밥",
    num: 16,
    name: "된장 우삼겹덮밥",
    price: 11500,
    salePrice: 11500,
    img: "16.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [0, 1, 2],
    isDescription: "고소한 우삼겹을 된장소스에 볶아낸 새로운 고기 덮밥",
    bedg: [],
  },
  {
    category: "짜글이",
    num: 17,
    name: "듬뿍 짜글이(조리 10분~15분)",
    price: 11000,
    salePrice: 11000,
    img: "17.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [1, 4, 5],
    isDescription:
      "충청도 향토음식을 전라도식 전통짜글이로 재구성한 1992덮밥&짜글이의 시그니처 메뉴(10~15분 조리시간 소요)",
    bedg: [],
  },
  {
    category: "짜글이",
    num: 18,
    name: "된장 짜글이(조리 10분~15분)",
    price: 11500,
    salePrice: 11500,
    img: "18.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: true,
    option: [1, 4],
    isDescription: "특제된장으로 끓여낸 진하고 구수한 전라도식 전통된장짜글이",
    bedg: ["추천"],
  },
  {
    category: "추가",
    num: 19,
    name: "계란찜 추가",
    price: 2000,
    salePrice: 2000,
    img: "19.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription: "",
    bedg: [],
  },
  {
    category: "추가",
    num: 20,
    name: "김치찌개 추가",
    price: 2000,
    salePrice: 2000,
    img: "20.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription: "",
    bedg: [],
  },
  {
    category: "추가",
    num: 21,
    name: "공기밥 추가",
    price: 1000,
    salePrice: 1000,
    img: "21.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription: "",
    bedg: [],
  },
  {
    category: "추가",
    num: 22,
    name: "계란이불밥 추가",
    price: 1500,
    salePrice: 1500,
    img: "22.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription: "",
    bedg: [],
  },
  {
    category: "사이드",
    num: 23,
    name: "쫄깃 꿀호떡 3개",
    price: 2500,
    salePrice: 2500,
    img: "23.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription: "",
    bedg: [],
  },
  {
    category: "사이드",
    num: 24,
    name: "튀김찐빵 4개",
    price: 1500,
    salePrice: 1500,
    img: "24.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription: "",
    bedg: [],
  },
  {
    category: "사이드",
    num: 25,
    name: "통통왕새우튀김 2개",
    price: 3000,
    salePrice: 3000,
    img: "25.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription: "",
    bedg: [],
  },
  {
    category: "사이드",
    num: 26,
    name: "통통김말이튀김 2개",
    price: 1500,
    salePrice: 1500,
    img: "26.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription: "",
    bedg: [],
  },
  {
    category: "사이드",
    num: 27,
    name: "치킨너겟 6조각",
    price: 2500,
    salePrice: 2500,
    img: "27.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription: "",
    bedg: [],
  },
  {
    category: "사이드",
    num: 28,
    name: "옛날핫도그",
    price: 1500,
    salePrice: 1500,
    img: "28.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription: "",
    bedg: [],
  },
  {
    category: "사이드",
    num: 29,
    name: "등심돈까스 1pcs",
    price: 3500,
    salePrice: 3500,
    img: "29.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription: "",
    bedg: [],
  },
  {
    category: "사이드",
    num: 30,
    name: "고구마치즈돈까스 1pcs",
    price: 4000,
    salePrice: 4000,
    img: "30.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription: "",
    bedg: [],
  },
  {
    category: "사이드",
    num: 31,
    name: "스팸구이",
    price: 4000,
    salePrice: 4000,
    img: "31.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription: "",
    bedg: [],
  },
  {
    category: "사이드",
    num: 32,
    name: "소세지구이 2개",
    price: 2000,
    salePrice: 2000,
    img: "32.png",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription: "",
    bedg: [],
  },
  {
    category: "사이드",
    num: 33,
    name: "고기 만두 튀김 3개",
    price: 3000,
    salePrice: 3000,
    img: "33.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription: "",
    bedg: [],
  },
  {
    category: "사이드",
    num: 34,
    name: "전주 수제 초코파이",
    price: 3000,
    salePrice: 3000,
    img: "34.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription: "촉촉하고 달달한 수제 초코파이",
    bedg: [],
  },
  {
    category: "사이드",
    num: 35,
    name: "치즈돈까스(조리12분)",
    price: 3800,
    salePrice: 3800,
    img: "35.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription:
      "모짜렐라 치즈가 가득 들어있는 바삭하고 두툼한 치즈 돈까스(조리시간 12~15분)",
    bedg: [],
  },
  {
    category: "사이드",
    num: 36,
    name: "멘보샤 4개",
    price: 5000,
    salePrice: 5000,
    img: "36.jpeg",
    isSale: true,
    isDiscount: false,
    option: [],
    isOption: false,
    isDescription: "",
    bedg: [],
  },
  {
    category: "사이드",
    num: 37,
    name: "멘보샤 2개",
    price: 2500,
    salePrice: 2500,
    img: "37.jpeg",
    isSale: true,
    isDiscount: false,
    option: [],
    isOption: false,
    isDescription: "",
    bedg: [],
  },
  {
    category: "음료",
    num: 38,
    name: "콜라",
    price: 1500,
    salePrice: 1500,
    img: "38.jpeg",
    isSale: true,
    isDiscount: false,
    option: [],
    isOption: false,
    isDescription: "",
    bedg: [],
  },
  {
    category: "음료",
    num: 39,
    name: "제로콜라",
    price: 1500,
    salePrice: 1500,
    img: "39.jpeg",
    isSale: true,
    isDiscount: false,
    option: [],
    isOption: false,
    isDescription: "",
    bedg: [],
  },
  {
    category: "음료",
    num: 40,
    name: "사이다",
    price: 1500,
    salePrice: 1500,
    img: "40.jpeg",
    isSale: true,
    isDiscount: false,
    option: [],
    isOption: false,
    isDescription: "",
    bedg: [],
  },
  {
    category: "음료",
    num: 41,
    name: "트레비 레몬",
    price: 2000,
    salePrice: 2000,
    img: "41.png",
    isSale: true,
    isDiscount: false,
    option: [],
    isOption: false,
    isDescription: "",
    bedg: [],
  },
  {
    category: "음료",
    num: 42,
    name: "립톤아이스티(복숭아)",
    price: 1500,
    salePrice: 1500,
    img: "42.png",
    isSale: true,
    isDiscount: false,
    option: [],
    isOption: false,
    isDescription: "",
    bedg: [],
  },
  {
    category: "음료",
    num: 43,
    name: "밀키스",
    price: 1500,
    salePrice: 1500,
    img: "43.png",
    isSale: true,
    isDiscount: false,
    option: [],
    isOption: false,
    isDescription: "",
    bedg: [],
  },
  {
    category: "음료",
    num: 44,
    name: "칠성사이다 제로",
    price: 1500,
    salePrice: 1500,
    img: "44.png",
    isSale: true,
    isDiscount: false,
    option: [],
    isOption: false,
    isDescription: "",
    bedg: [],
  },
  {
    category: "음료",
    num: 45,
    name: "탐스제로 파인애플",
    price: 1500,
    salePrice: 1500,
    img: "45.png",
    isSale: true,
    isDiscount: false,
    option: [],
    isOption: false,
    isDescription: "",
    bedg: [],
  },
  {
    category: "음료",
    num: 46,
    name: "탐스제로 오렌지",
    price: 1500,
    salePrice: 1500,
    img: "46.png",
    isSale: true,
    isDiscount: false,
    option: [],
    isOption: false,
    isDescription: "",
    bedg: [],
  },
  {
    category: "음료",
    num: 47,
    name: "탐스제로 애플키위",
    price: 1500,
    salePrice: 1500,
    img: "47.png",
    isSale: true,
    isDiscount: false,
    option: [],
    isOption: false,
    isDescription: "",
    bedg: [],
  },
  {
    category: "음료",
    num: 48,
    name: "탐스제로 청포도·석류",
    price: 1500,
    salePrice: 1500,
    img: "48.jpeg",
    isSale: true,
    isDiscount: false,
    isOption: false,
    option: [],
    isDescription: "",
    bedg: [],
  },
  {
    category: "음료",
    num: 49,
    name: "탐스제로 레몬",
    price: 1500,
    salePrice: 1500,
    img: "49.jpeg",
    isSale: true,
    isDiscount: false,
    option: [],
    isOption: false,
    isDescription: "",
    bedg: [],
  },
];
// export const menuListData = [
//   {
//     category: "전채요리",
//     num: 1,
//     name: "튀긴 칼라마리",
//     price: 10900,
//     salePrice: 10900,
//     img: "1.webp",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: ["추천", "대표메뉴", "인기"],
//   },
//   {
//     category: "전채요리",
//     num: 2,
//     name: "카프레제 샐러드",
//     price: 8900,
//     salePrice: 8900,
//     img: "2.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: ["추천", "인기"],
//   },
//   {
//     category: "전채요리",
//     num: 3,
//     name: "포테이토 스킨",
//     price: 7900,
//     salePrice: 7900,
//     img: "3.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: ["추천", "맵기1"],
//   },
//   {
//     category: "전채요리",
//     num: 4,
//     name: "새싹채소",
//     price: 9900,
//     salePrice: 9900,
//     img: "4.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     isDescription: "",
//     bedg: ["추천"],
//   },
//   {
//     category: "전채요리",
//     num: 5,
//     name: "허니 바베큐 치킨",
//     price: 11900,
//     salePrice: 11900,
//     img: "5.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     isDescription: "",
//     bedg: ["NEW"],
//   },
//   {
//     category: "전채요리",
//     num: 6,
//     name: "매콤한 미니 타코",
//     price: 10900,
//     salePrice: 10900,
//     img: "6.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     isDescription: "",
//     bedg: ["맵기3"],
//   },
//   {
//     category: "전채요리",
//     num: 7,
//     name: "크림 새우",
//     price: 12900,
//     salePrice: 12900,
//     img: "7.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: ["추천", "NEW"],
//   },
//   {
//     category: "전채요리",
//     num: 8,
//     name: "버팔로 치킨 스트립",
//     price: 10900,
//     salePrice: 10900,
//     img: "8.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: ["맵기2"],
//   },
//   {
//     category: "전채요리",
//     num: 9,
//     name: "아보카도 토마토",
//     price: 8900,
//     salePrice: 8900,
//     img: "9.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: ["추천"],
//   },
//   {
//     category: "전채요리",
//     num: 10,
//     name: "고구마 튀김",
//     price: 9900,
//     salePrice: 9900,
//     img: "10.webp",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     isDescription: "",
//     bedg: ["추천"],
//   },
//   {
//     category: "전채요리",
//     num: 11,
//     name: "치킨 텐더",
//     price: 11900,
//     salePrice: 11900,
//     img: "11.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     isDescription: "",
//     bedg: ["맵기3"],
//   },
//   {
//     category: "전채요리",
//     num: 12,
//     name: "후라이드 치킨 윙스",
//     price: 10900,
//     salePrice: 10900,
//     img: "12.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     isDescription: "",
//     bedg: ["맵기3"],
//   },
//   {
//     category: "전채요리",
//     num: 13,
//     name: "로스트드 감자",
//     price: 9900,
//     salePrice: 9900,
//     img: "13.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: ["추천"],
//   },
//   {
//     category: "전채요리",
//     num: 14,
//     name: "고구마 크림 스프",
//     price: 8900,
//     salePrice: 8900,
//     img: "14.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: ["추천"],
//   },
//   {
//     category: "전채요리",
//     num: 15,
//     name: "로즈마리 감자 튀김",
//     price: 10900,
//     salePrice: 10900,
//     img: "15.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: ["추천"],
//   },
//   {
//     category: "전채요리",
//     num: 16,
//     name: "고르곤졸라 치즈볼",
//     price: 11900,
//     salePrice: 11900,
//     img: "16.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "전채요리",
//     num: 17,
//     name: "치즈와 양파 스프",
//     price: 8900,
//     salePrice: 8900,
//     img: "17.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "전채요리",
//     num: 18,
//     name: "브리 스핀치 팝버터",
//     price: 9900,
//     salePrice: 9900,
//     img: "18.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "전채요리",
//     num: 19,
//     name: "머쉬룸 크림 수프",
//     price: 8900,
//     salePrice: 8900,
//     img: "19.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "전채요리",
//     num: 20,
//     name: "새우 칵테일",
//     price: 12900,
//     salePrice: 12900,
//     img: "20.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "주요요리",
//     num: 21,
//     name: "감자 퓨레와 스테이크",
//     price: 19900,
//     salePrice: 19900,
//     img: "21.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "주요요리",
//     num: 22,
//     name: "그릴 연어와 아스파라거스",
//     price: 18900,
//     salePrice: 18900,
//     img: "22.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "주요요리",
//     num: 23,
//     name: "BBQ 리브와 콜 슬로우",
//     price: 16900,
//     salePrice: 16900,
//     img: "23.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "주요요리",
//     num: 24,
//     name: "로제마리 로스티드 포크 벨리",
//     price: 18900,
//     salePrice: 18900,
//     img: "24.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     isDescription: "",
//     bedg: ["추천"],
//   },
//   {
//     category: "주요요리",
//     num: 25,
//     name: "살라미와 오이 소스의 그릴 치킨",
//     price: 17900,
//     salePrice: 17900,
//     img: "25.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "주요요리",
//     num: 26,
//     name: "매콤한 베이컨 랍스터",
//     price: 22900,
//     salePrice: 22900,
//     img: "26.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     isDescription: "",
//     bedg: ["맵기2"],
//   },
//   {
//     category: "주요요리",
//     num: 27,
//     name: "무스마엘 스테이크와 홀스래디쉬 소스",
//     price: 21900,
//     salePrice: 21900,
//     img: "27.webp",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "주요요리",
//     num: 28,
//     name: "로제마리 치킨 브레스트",
//     price: 16900,
//     salePrice: 16900,
//     img: "28.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "주요요리",
//     num: 29,
//     name: "베이컨 랩과 슬라이스 아보카도",
//     price: 19900,
//     salePrice: 19900,
//     img: "29.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "주요요리",
//     num: 30,
//     name: "숄더렉 스테이크 세트",
//     price: 120900,
//     salePrice: 120900,
//     img: "30.jpeg",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     bedg: ["대표메뉴", "추천"],
//     isDescription:
//       "(양고기 : 호주산)<br/>미디엄 레어 램 랙에는 샐러드 2개와 파스타와 와인이 같이 제공됩니다.<br/>가니시는 쉐프 초이스로 운영되며 시즌에 따라 변경될 수 있습니다.",
//   },
//   {
//     category: "버거",
//     num: 31,
//     name: "클래식 치즈버거",
//     price: 11900,
//     salePrice: 11900,
//     img: "31.jpg",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "버거",
//     num: 32,
//     name: "베이컨 아보카도 버거",
//     price: 13900,
//     salePrice: 13900,
//     img: "32.jpg",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "버거",
//     num: 33,
//     name: "버섯 스위스 버거",
//     price: 12900,
//     salePrice: 12900,
//     img: "33.jpg",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "파스타",
//     num: 34,
//     name: "스파게티 볼로네제",
//     price: 15000,
//     salePrice: 12900,
//     img: "34.jpg",
//     isSale: true,
//     isDiscount: true,
//     isOption: false,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "파스타",
//     num: 35,
//     name: "페투치네 알프레도",
//     price: 14000,
//     salePrice: 11900,
//     img: "35.jpg",
//     isSale: true,
//     isDiscount: true,
//     isOption: false,
//     isDescription: "",
//     bedg: ["맵기1"],
//   },
//   {
//     category: "파스타",
//     num: 36,
//     name: "페스토 리구이니",
//     price: 10900,
//     salePrice: 10900,
//     img: "36.jpg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: ["맵기1"],
//   },
//   {
//     category: "파스타",
//     num: 37,
//     name: "바질 파스타",
//     price: 11900,
//     salePrice: 11900,
//     img: "37.jpg",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     isDescription: "",
//     bedg: ["NEW"],
//   },
//   {
//     category: "파스타",
//     num: 38,
//     name: "씨푸드 토마토 소스 스파게티",
//     price: 13900,
//     salePrice: 13900,
//     img: "38.jpg",
//     isSale: true,
//     isDiscount: false,
//     isOption: true,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "음료",
//     num: 39,
//     name: "아이스티",
//     price: 2990,
//     salePrice: 2990,
//     img: "39.jpg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "음료",
//     num: 40,
//     name: "커피",
//     price: 2990,
//     salePrice: 2990,
//     img: "40.jpg",
//     isSale: true,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "음료",
//     num: 41,
//     name: "프레시 오렌지 주스",
//     price: 3490,
//     salePrice: 3490,
//     img: "41.jpg",
//     isSale: false,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: [],
//   },
//   {
//     category: "음료",
//     num: 42,
//     name: "플랫 화이트",
//     price: 4500,
//     salePrice: 4500,
//     img: "42.jpg",
//     isSale: false,
//     isDiscount: false,
//     isOption: false,
//     isDescription: "",
//     bedg: [],
//   },
// ];
